export namespace ErrorCodes {
    export const UNAUTHORIZED_USER = 'AUT-401';
    export const FILE_TITLE_IN_USE = 'AUF-420';
    export const FILE_IS_IN_USE = 'AUF-419';
}
export namespace ErrorReasonCodes {
    export const FILE_IS_USED = 'FileIsUsed';
}